import { INITIAL_SAVE_REQUEST_META } from '../utils';
import { BlockedUsernamesWidgetData } from './types';

const defaultBlockedUsernamesWidgetData: NonNullable<BlockedUsernamesWidgetData['initialData']> = {
  blockedUsers: [],
};

export const defaultBlockedUsernamesWidgetState: BlockedUsernamesWidgetData = {
  initialData: defaultBlockedUsernamesWidgetData,
  currentData: defaultBlockedUsernamesWidgetData,
  isDirty: false,
  saveRequest: INITIAL_SAVE_REQUEST_META,
};
